import React, { useState } from 'react';
import { Alert, Button, Snackbar } from '@mui/material';
import { useAuth } from '../../context/AuthContext';

export default function AuthorizationNotice() {
  const { permissionError, refreshAuthorization } = useAuth();
  const [retrying, setRetrying] = useState(false);
  if (!permissionError) return null;
  const retry = async () => {
    setRetrying(true);
    try {
      await refreshAuthorization();
    } catch (error) {
      console.error('No se pudo volver a comprobar el acceso:', error);
    } finally {
      setRetrying(false);
    }
  };
  return <Snackbar open anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
    <Alert severity="warning" sx={{ alignItems: 'center', flexWrap: 'wrap', maxWidth: 760 }}
    action={<Button color="inherit" disabled={retrying} onClick={retry} sx={{ minHeight: 44 }}>
      {retrying ? 'Comprobando acceso…' : 'Reintentar acceso'}
    </Button>}>
    {permissionError}
    </Alert>
  </Snackbar>;
}
